import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Community.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import CommunityRoomsPanel from '../../components/CommunityRoomsPanel';

export default function Community() {
  const navigate = useNavigate();
  const [newPost, setNewPost] = useState('');
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [postForm, setPostForm] = useState({
    title: '',
    content: '',
    category: '',
    tags: '',
    privacy: 'public',
    image: null
  });

  const handleCreatePost = () => {
    if (newPost.trim()) {
      // In a real app, this would send to backend
      console.log('Creating post:', newPost);
      alert('Bài đăng đã được tạo thành công!');
      setNewPost('');
    } else {
      alert('Vui lòng viết gì đó trước khi đăng!');
    }
  };

  const handleCreateDetailedPost = () => {
    if (!postForm.title.trim() || !postForm.content.trim()) {
      alert('Vui lòng điền tiêu đề và nội dung!');
      return;
    }
    
    // In a real app, this would send to backend
    console.log('Creating detailed post:', postForm);
    alert('Bài đăng chi tiết đã được tạo thành công!');
    
    // Reset form
    setPostForm({
      title: '',
      content: '',
      category: '',
      tags: '',
      privacy: 'public',
      image: null
    });
    setShowCreateForm(false);
  };

  const handleFormChange = (field, value) => {
    setPostForm(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setPostForm(prev => ({
        ...prev,
        image: file
      }));
    }
  };


  const handlePostClick = (postId) => {
    // Navigate to a detailed post view (you might want to create this route)
    console.log('Opening post:', postId);
    // navigate(`/community/post/${postId}`);
  };

  

  const posts = [
    {
      id: 1,
      title: "Hành trình chữa lành tâm hồn: Từ trầm cảm đến hạnh phúc",
      content: "Sau 2 năm đấu tranh với trầm cảm, tôi đã tìm thấy ánh sáng. Chia sẻ những bài học quý giá về việc chấp nhận bản thân, tìm kiếm sự giúp đỡ và xây dựng lại cuộc sống. Mỗi ngày là một cơ hội mới để yêu thương chính mình.",
      image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&h=200&fit=crop",
      tags: ["chữa lành", "trầm cảm", "hành trình", "tự yêu thương"],
      author: "Minh Anh",
      timeAgo: "2 ngày trước",
    },
    {
      id: 2,
      title: "Nhạc chữa lành: 10 bài hát giúp tôi vượt qua cơn khủng hoảng",
      content: "Âm nhạc đã trở thành người bạn đồng hành trong hành trình chữa lành của tôi. Từ những giai điệu nhẹ nhàng đến những ca từ sâu sắc, mỗi bài hát đều mang đến sự an ủi và hy vọng. Link playlist: [Spotify Healing Music](https://open.spotify.com/playlist/37i9dQZF1DX3Ogo9pFvBkY)",
      image: "https://images.unsplash.com/photo-1493225457124-a3b1616bbab5?w=400&h=200&fit=crop",
      tags: ["nhạc chữa lành", "playlist", "âm nhạc", "an ủi"],
      author: "Linh Chi",
      timeAgo: "5 ngày trước",
    },
    {
      id: 3,
      title: "Thiền chánh niệm: Cách tôi học cách sống với hiện tại",
      content: "Sau khi mất người thân, tôi rơi vào trạng thái lo âu và sợ hãi về tương lai. Thiền chánh niệm đã dạy tôi cách chấp nhận cảm xúc và tìm thấy sự bình yên trong từng khoảnh khắc. Chia sẻ 5 bài tập thiền đơn giản mà ai cũng có thể làm.",
      image: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=400&h=200&fit=crop",
      tags: ["thiền", "chánh niệm", "lo âu", "bình yên"],
      author: "Hương Giang",
      timeAgo: "1 tuần trước",
    },
    {
      id: 4,
      title: "Viết nhật ký cảm xúc: Công cụ mạnh mẽ để hiểu bản thân",
      content: "Viết nhật ký đã giúp tôi nhận ra những mẫu suy nghĩ tiêu cực và học cách thay đổi chúng. Mỗi trang viết là một bước tiến trong hành trình tự khám phá. Chia sẻ template viết nhật ký cảm xúc miễn phí.",
      image: "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=400&h=200&fit=crop",
      tags: ["viết nhật ký", "cảm xúc", "tự khám phá", "template"],
      author: "Đức Minh",
      timeAgo: "3 ngày trước",
    },
    {
      id: 5,
      title: "Kết nối với thiên nhiên: Liệu pháp xanh cho tâm hồn",
      content: "Dành 30 phút mỗi ngày trong công viên đã thay đổi hoàn toàn tâm trạng của tôi. Thiên nhiên có sức mạnh chữa lành mà không cần thuốc. Chia sẻ những địa điểm xanh ở Hà Nội và TP.HCM để bạn có thể thử nghiệm.",
      image: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=400&h=200&fit=crop",
      tags: ["thiên nhiên", "liệu pháp xanh", "công viên", "chữa lành"],
      author: "Mai Phương",
      timeAgo: "1 tuần trước",
    },
    {
      id: 6,
      title: "Những câu nói tích cực giúp tôi vượt qua ngày khó khăn",
      content: "Khi cảm thấy chán nản, tôi thường đọc lại những câu nói truyền cảm hứng. Chia sẻ bộ sưu tập 50 câu nói đã giúp tôi vượt qua những thời điểm khó khăn nhất. Mỗi câu đều có ý nghĩa sâu sắc và dễ nhớ.",
      image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=400&h=200&fit=crop",
      tags: ["câu nói tích cực", "truyền cảm hứng", "vượt khó", "tư duy tích cực"],
      author: "Quang Huy",
      timeAgo: "4 ngày trước",
    }
  ];

  const popularTags = [
    { name: "chữa lành", posts: "12,456", trending: true, description: "Xu hướng - Hành trình chữa lành" },
    { name: "trầm cảm", posts: "8,923", description: "Hỗ trợ trầm cảm" },
    { name: "lo âu", posts: "7,834", trending: true, description: "Xu hướng - Quản lý lo âu" },
    { name: "thiền", posts: "6,789", description: "Thiền và chánh niệm" },
    { name: "nhạc chữa lành", posts: "5,234", trending: true, description: "Xu hướng - Âm nhạc chữa lành" },
    { name: "tự yêu thương", posts: "4,567", description: "Học cách yêu thương bản thân" },
    { name: "viết nhật ký", posts: "3,891", description: "Viết nhật ký cảm xúc" },
    { name: "thiên nhiên", posts: "3,456", description: "Liệu pháp xanh" }
  ];

  const pinnedGroups = [
    { name: "hành trình chữa lành", posts: "15,234", trending: true, description: "Xu hướng - Chia sẻ hành trình" },
    { name: "hỗ trợ tâm lý", posts: "12,567", description: "Nhóm hỗ trợ tâm lý" },
    { name: "thiền và chánh niệm", posts: "9,876", trending: true, description: "Xu hướng - Thực hành thiền" },
    { name: "âm nhạc chữa lành", posts: "8,432", description: "Chia sẻ nhạc chữa lành" },
    { name: "viết nhật ký", posts: "7,654", trending: true, description: "Xu hướng - Viết nhật ký" }
  ];

  const onlineSessions = [
    { 
      date: "FEB 7", 
      title: "Trị liệu Nhóm cho Kiệt sức", 
      location: "Viet Nam • HCM",
      tags: ["Từ xa", "Bán thời gian", "Toàn cầu"]
    },
    { 
      date: "FEB 3", 
      title: "Hỏi đáp Trực tiếp: Đối phó với Mối quan hệ...", 
      location: "Viet Nam • HCM",
      tags: ["Từ xa", "Bán thời gian"]
    },
    { 
      date: "FEB 5", 
      title: "Thiền có Hướng dẫn + Vòng tròn Chia sẻ", 
      location: "Viet Nam • HCM",
      tags: ["Toàn thời gian", "Hợp đồng", "Toàn cầu"]
    }
  ];

  const podcasts = [
    { 
      title: "Hành trình chữa lành tâm hồn - Tập 1: Từ đau khổ đến hạnh phúc", 
      author: "Dr. Minh Anh",
      image: "https://images.unsplash.com/photo-1478737270239-2f02b77fc618?w=60&h=60&fit=crop",
      link: "https://open.spotify.com/episode/4rODxMx8jKqJgqJqJqJqJq",
      description: "Chia sẻ về quá trình chữa lành từ trầm cảm và tìm lại niềm vui sống"
    },
    { 
      title: "Nhạc chữa lành: Playlist cho tâm hồn", 
      author: "Linh Chi Music",
      image: "https://images.unsplash.com/photo-1493225457124-a3b1616bbab5?w=60&h=60&fit=crop",
      link: "https://open.spotify.com/playlist/37i9dQZF1DX3Ogo9pFvBkY",
      description: "Tuyển tập những bài hát giúp chữa lành và an ủi tâm hồn"
    },
    { 
      title: "Thiền chánh niệm cho người mới bắt đầu", 
      author: "Thầy Hương Giang",
      image: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=60&h=60&fit=crop",
      link: "https://www.youtube.com/watch?v=inpok4MKVLM",
      description: "Hướng dẫn thiền cơ bản cho người mới bắt đầu hành trình chữa lành"
    },
    { 
      title: "Viết nhật ký cảm xúc - Công cụ tự chữa lành", 
      author: "Đức Minh",
      image: "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=60&h=60&fit=crop",
      link: "https://www.youtube.com/watch?v=example",
      description: "Cách viết nhật ký để hiểu và chữa lành cảm xúc"
    },
    { 
      title: "Liệu pháp thiên nhiên cho sức khỏe tinh thần", 
      author: "Mai Phương",
      image: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=60&h=60&fit=crop",
      link: "https://www.youtube.com/watch?v=example2",
      description: "Khám phá sức mạnh chữa lành của thiên nhiên"
    },
    { 
      title: "Tư duy tích cực - Chìa khóa hạnh phúc", 
      author: "Quang Huy",
      image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=60&h=60&fit=crop",
      link: "https://www.youtube.com/watch?v=example3",
      description: "Cách xây dựng tư duy tích cực trong cuộc sống hàng ngày"
    }
  ];

  return (
    <div className="community-page page-with-header">
      <Header />
      
      <div className="community-main">
        <div className="community-container">
          {/* Left Sidebar */}
          <div className="community-sidebar left">
            <div className="sidebar-section">
              <h3 className="sidebar-title">
                <span className="sidebar-icon">🆕</span>
                Mới nhất và Gần đây
              </h3>
              <p className="sidebar-description">Tìm các cập nhật mới nhất và nội dung mới</p>
            </div>
            
            <div className="sidebar-section">
              <h3 className="sidebar-title">
                <span className="sidebar-icon">🔥</span>
                Phổ biến trong ngày
              </h3>
              <p className="sidebar-description">Nội dung xu hướng được giới thiệu bởi các biên tập viên của chúng tôi</p>
            </div>
            
            <div className="sidebar-section">
              <h3 className="sidebar-title">
                <span className="sidebar-icon">👥</span>
                Đang theo dõi
                <span className="notification-badge">24</span>
              </h3>
              <p className="sidebar-description">Khám phá từ những người bạn yêu thích</p>
            </div>
            
            <div className="sidebar-section">
              <h3 className="sidebar-title">
                <span className="sidebar-icon">🏷️</span>
                Thẻ phổ biến
              </h3>
              <div className="tags-list">
                {popularTags.map((tag, index) => (
                  <div key={index} className="tag-item">
                    <span className="tag-name">
                      #{tag.name}
                      {tag.trending && <span className="trending-indicator">🔥</span>}
                    </span>
                    {tag.posts && (
                      <span className="tag-posts">
                        {tag.posts} {tag.description}
                      </span>
                    )}
                  </div>
                ))}
              </div>
            </div>
            
            <div className="sidebar-section">
              <h3 className="sidebar-title">
                <span className="sidebar-icon">📌</span>
                Nhóm đã ghim
              </h3>
              <div className="tags-list">
                {pinnedGroups.map((group, index) => (
                  <div key={index} className="tag-item">
                    <span className="tag-name">
                      #{group.name}
                      {group.trending && <span className="trending-indicator">🔥</span>}
                    </span>
                    {group.posts && (
                      <span className="tag-posts">
                        {group.posts} {group.description}
                      </span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Main Content Feed */}
          <div className="community-feed">
              {/* Link to Messenger-style Free Chat for rooms */}
              <div style={{marginBottom:12}}>
                <button onClick={() => navigate('/free-chat')} style={{padding:'8px 12px', borderRadius:6, background:'#6b46c1', color:'#fff', border:'none'}}>Mở Phòng Trò chuyện</button>
              </div>

            <div className="create-post">
              <div className="user-avatar">👤</div>
              <input 
                type="text" 
                placeholder="Hãy chia sẻ những gì đang diễn ra trong tâm trí bạn..."
                value={newPost}
                onChange={(e) => setNewPost(e.target.value)}
                className="post-input"
              />
              <button className="create-post-btn" onClick={handleCreatePost}>Tạo bài đăng</button>
              <button 
                className="detailed-post-btn" 
                onClick={() => setShowCreateForm(true)}
              >
                📝 Bài đăng chi tiết
              </button>
            </div>

            {/* Detailed Post Creation Form */}
            {showCreateForm && (
              <div className="detailed-post-form">
                <div className="form-header">
                  <h3>Tạo bài đăng chi tiết</h3>
                  <button 
                    className="close-form-btn"
                    onClick={() => setShowCreateForm(false)}
                  >
                    ✕
                  </button>
                </div>
                
                <div className="form-content">
                  <div className="form-description">
                    <p>Chia sẻ câu chuyện, kinh nghiệm hoặc đặt câu hỏi để nhận được sự hỗ trợ từ cộng đồng. Mọi chia sẻ đều được tôn trọng và bảo mật.</p>
                  </div>
                  
                  <div className="form-tips-section">
                    <div className="form-tips">
                      <h4>💡 Mẹo viết bài hiệu quả:</h4>
                      <div className="tips-row">
                        <div className="tip-row">
                          <div className="tip-item">
                            <span className="tip-icon">📝</span>
                            <span>Tiêu đề rõ ràng</span>
                          </div>
                          <div className="tip-item">
                            <span className="tip-icon">📖</span>
                            <span>Chia sẻ chi tiết</span>
                          </div>
                        </div>
                        <div className="tip-row">
                          <div className="tip-item">
                            <span className="tip-icon">🏷️</span>
                            <span>Sử dụng thẻ</span>
                          </div>
                          <div className="tip-item">
                            <span className="tip-icon">🔒</span>
                            <span>Quyền riêng tư</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="post-title">Tiêu đề *</label>
                    <input
                      id="post-title"
                      type="text"
                      placeholder="Nhập tiêu đề bài đăng..."
                      value={postForm.title}
                      onChange={(e) => handleFormChange('title', e.target.value)}
                      className="form-input"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="post-content">Nội dung *</label>
                    <textarea
                      id="post-content"
                      placeholder="Chia sẻ suy nghĩ, trải nghiệm của bạn hoặc đặt câu hỏi..."
                      value={postForm.content}
                      onChange={(e) => handleFormChange('content', e.target.value)}
                      className="form-textarea"
                      rows="4"
                    />
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="post-category">Danh mục</label>
                      <select
                        id="post-category"
                        value={postForm.category}
                        onChange={(e) => handleFormChange('category', e.target.value)}
                        className="form-select"
                      >
                        <option value="">Chọn danh mục...</option>
                        <option value="mental-health">Sức khỏe tinh thần</option>
                        <option value="therapy">Trị liệu</option>
                        <option value="support">Hỗ trợ</option>
                        <option value="experience">Trải nghiệm cá nhân</option>
                        <option value="question">Câu hỏi</option>
                        <option value="advice">Lời khuyên</option>
                        <option value="other">Khác</option>
                      </select>
                    </div>

                    <div className="form-group">
                      <label htmlFor="post-privacy">Quyền riêng tư</label>
                      <select
                        id="post-privacy"
                        value={postForm.privacy}
                        onChange={(e) => handleFormChange('privacy', e.target.value)}
                        className="form-select"
                      >
                        <option value="public">Công khai</option>
                        <option value="friends">Chỉ bạn bè</option>
                        <option value="private">Riêng tư</option>
                      </select>
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="post-tags">Thẻ (phân cách bằng dấu phẩy)</label>
                    <input
                      id="post-tags"
                      type="text"
                      placeholder="ví dụ: lo âu, trầm cảm, trị liệu, hỗ trợ"
                      value={postForm.tags}
                      onChange={(e) => handleFormChange('tags', e.target.value)}
                      className="form-input"
                    />
                    <div className="popular-tags">
                      <span className="tags-label">Thẻ phổ biến:</span>
                      <div className="tag-suggestions-row">
                        <div className="tag-row">
                          <span className="tag-suggestion" onClick={() => handleFormChange('tags', postForm.tags ? `${postForm.tags}, lo âu` : 'lo âu')}>#lo âu</span>
                          <span className="tag-suggestion" onClick={() => handleFormChange('tags', postForm.tags ? `${postForm.tags}, trầm cảm` : 'trầm cảm')}>#trầm cảm</span>
                          <span className="tag-suggestion" onClick={() => handleFormChange('tags', postForm.tags ? `${postForm.tags}, trị liệu` : 'trị liệu')}>#trị liệu</span>
                        </div>
                        <div className="tag-row">
                          <span className="tag-suggestion" onClick={() => handleFormChange('tags', postForm.tags ? `${postForm.tags}, hỗ trợ` : 'hỗ trợ')}>#hỗ trợ</span>
                          <span className="tag-suggestion" onClick={() => handleFormChange('tags', postForm.tags ? `${postForm.tags}, chánh niệm` : 'chánh niệm')}>#chánh niệm</span>
                          <span className="tag-suggestion" onClick={() => handleFormChange('tags', postForm.tags ? `${postForm.tags}, tự chăm sóc` : 'tự chăm sóc')}>#tự chăm sóc</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="post-image">Thêm hình ảnh (Tùy chọn)</label>
                    <input
                      id="post-image"
                      type="file"
                      accept="image/*"
                      onChange={handleImageUpload}
                      className="form-file"
                    />
                    {postForm.image && (
                      <div className="image-preview">
                        <span>Đã chọn: {postForm.image.name}</span>
                      </div>
                    )}
                  </div>

                  <div className="form-info">
                    <div className="info-row">
                      <div className="info-item">
                        <span className="info-icon">🔒</span>
                        <span>Bảo mật</span>
                      </div>
                      <div className="info-item">
                        <span className="info-icon">👥</span>
                        <span>Hỗ trợ 24/7</span>
                      </div>
                      <div className="info-item">
                        <span className="info-icon">💬</span>
                        <span>Chuyên gia</span>
                      </div>
                    </div>
                  </div>

                  <div className="form-actions">
                    <button 
                      className="cancel-btn"
                      onClick={() => setShowCreateForm(false)}
                    >
                      Hủy
                    </button>
                    <button 
                      className="submit-btn"
                      onClick={handleCreateDetailedPost}
                    >
                      Tạo bài đăng
                    </button>
                  </div>
                </div>
              </div>
            )}
            
            <div className="posts-list">
              {posts.map((post) => (
                <div key={post.id} className="post-card" onClick={() => handlePostClick(post.id)}>
                  <div className="post-image">
                    <img src={post.image} alt={post.title} />
                  </div>
                  <div className="post-content">
                    <h3 className="post-title">{post.title}</h3>
                    {post.content && (
                      <div className="post-description">
                        {post.content.length > 200 
                          ? `${post.content.substring(0, 200)}...` 
                          : post.content
                        }
                      </div>
                    )}
                    <div className="post-tags">
                      {post.tags.map((tag, index) => (
                        <span key={index} className="post-tag">#{tag}</span>
                      ))}
                    </div>
                    <div className="post-meta">
                      <span className="post-author">{post.author}</span>
                      <span className="post-time">{post.timeAgo}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Sidebar */}
          <div className="community-sidebar right">
            <div className="sidebar-section">
              <h3 className="sidebar-title">
                <span className="sidebar-icon">🎯</span>
                Buổi học trực tuyến
              </h3>
              <div className="sessions-list">
                {onlineSessions.map((session, index) => (
                  <div key={index} className="session-item">
                    <div className="session-date">{session.date}</div>
                    <div className="session-title">{session.title}</div>
                    <div className="session-location">{session.location}</div>
                    <div className="session-tags">
                      {session.tags.map((tag, tagIndex) => (
                        <span key={tagIndex} className="session-tag">{tag}</span>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="sidebar-section">
              <h3 className="sidebar-title">
                <span className="sidebar-icon">🎧</span>
                Podcast
              </h3>
              <div className="podcasts-list">
                {podcasts.map((podcast, index) => (
                  <div key={index} className="podcast-item" onClick={() => window.open(podcast.link, '_blank')}>
                    <img src={podcast.image} alt={podcast.title} className="podcast-image" />
                    <div className="podcast-content">
                      <div className="podcast-title">{podcast.title}</div>
                      <div className="podcast-author">bởi {podcast.author}</div>
                      <div className="podcast-description">{podcast.description}</div>
                    </div>
                    <div className="podcast-arrow">🔗</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
}

